import angular from 'angular';
import toolbarService from './ToolbarService';
import sectionsLibraryService from './../SectionsLibrary/SectionsLibraryService';

const creatorToolbar = {
    bindings: {
        model: '=',
        context: '<',
        options: '<' // {withScroll: boolean}
    },
    transclude: true,
    template: require('./toolbar.html'),
    controller: function(ToolbarService, SectionsLibraryService) {

        this.getSectionConfigSchema = (type) => {
          return ToolbarService.getSectionSchema(type);
        };

        this.getSectionDefinition = (type) => {
            return SectionsLibraryService.getSectionDefinition(type);
        };

        this.closeToolbar = () => {
          this.context.clearCurrentElement();
        };

        this.isCurrentElement = () => {
            if(!this.context) {
                return false;
            }
            return this.context.hasCurrentElement();
        };
    }
};

export default angular.module('cms.creator.toolbar', [toolbarService, sectionsLibraryService])
  .component('creatorToolbar', creatorToolbar).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Toolbar/Toolbar.js